import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import Button from "../../../../../../../../../components/shared/Button";
import Select from "../../../../../../../../../components/shared/inputs/Select";

function Pagination({ page, perPage, setPage, setPerPage, totalItems }: any) {
    const { t } = useTranslation();

    const totalPages = Math.ceil(totalItems / perPage) || 1;
    const currentPage = page + 1;

    const goToPage = useCallback((value: number) => {
        setPage(value)
    }, [setPage]);

    const onPageSizeChange = useCallback((value: string) => {
        setPerPage(value);
    }, [setPerPage]);

    return totalItems > 0 && (
        <div className="tw-flex tw-items-center tw-justify-between tw-py-2">
            <div />
            <div className="tw-flex tw-items-center tw-space-x-6 lg:tw-space-x-8">
                <div className="tw-flex tw-items-center tw-space-x-2">
                    <p className="tw-font-medium tw-text-sm">{t("rows-per-page")}</p>
                    <Select
                        value={`${perPage}`}
                        onChange={onPageSizeChange}
                        showSearch={false}
                        className="tw-w-[70px]"
                    >
                        {[10, 20, 30, 40, 50].map((pageSize) => (
                            <Select.Item key={pageSize} value={`${pageSize}`}>
                                {pageSize}
                            </Select.Item>
                        ))}
                    </Select>
                </div>
                <div className="tw-flex tw-w-[100px] tw-items-center tw-justify-center tw-font-medium tw-text-sm">
                    {t("page", {
                        current: currentPage,
                        total: totalPages,
                    })}
                </div>
                <div className="tw-flex tw-items-center tw-space-x-2">
                    <Button
                        variant="outline"
                        className="tw-hidden tw-h-8 tw-w-8 tw-p-0 lg:tw-flex"
                        onClick={() => goToPage(0)}
                        disabled={currentPage === 1}
                    >
                        <span className="tw-sr-only">{t("go-to-first-page")}</span>
                        <ChevronsLeft className="tw-h-4 tw-w-4" />
                    </Button>
                    <Button
                        variant="outline"
                        className="tw-h-8 tw-w-8 tw-p-0"
                        onClick={() => goToPage(page - 1)}
                        disabled={currentPage === 1}
                    >
                        <span className="tw-sr-only">{t("go-to-previous-page")}</span>
                        <ChevronLeft className="tw-h-4 tw-w-4" />
                    </Button>
                    <Button
                        variant="outline"
                        className="tw-h-8 tw-w-8 tw-p-0"
                        onClick={() => goToPage(page + 1)}
                        disabled={currentPage === totalPages}
                    >
                        <span className="tw-sr-only">{t("go-to-next-page")}</span>
                        <ChevronRight className="tw-h-4 tw-w-4" />
                    </Button>
                    <Button
                        variant="outline"
                        className="tw-hidden tw-h-8 tw-w-8 tw-p-0 lg:tw-flex"
                        onClick={() => goToPage(totalPages - 1)}
                        disabled={currentPage === totalPages}
                    >
                        <span className="tw-sr-only">{t("go-to-last-page")}</span>
                        <ChevronsRight className="tw-h-4 tw-w-4" />
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Pagination;
